import styled from 'styled-components';

import style from '../../../../../style';

interface WrapperProps {
  $scrollBlocked: boolean;
}

export const Wrapper = styled.div<WrapperProps>(
  ({ $scrollBlocked, theme, theme: { size } }) => ({
    width: '100%',
    height: 'auto',
    flexGrow: 1,

    ...($scrollBlocked
      ? {
          paddingRight: size.units(2),
        }
      : {
          overflowX: 'hidden',
          paddingRight: size.units(1.2),
          scrollbarGutter: 'stable',

          ...style.mixins.scrollbar(theme),
        }),
  }),
);
